import {  useEffect, useMemo, useState } from "react";
import { useNavigate } from "react-router-dom";
import {
  useGetPaginatedDoctypeDataQuery,
  useGetwarehouseCountQuery,
  useGetWarehouseOnlyParentDataMutation
} from '../../../../../store/api/warehousemaster';

import ActionButtonDropdown from "../../../../../Components/ActionButtonDropdown";
import Pagination from "../../../../../Core/Pagination/Pagination";
import ListLayout from "../../../../../Core/Layout/ListLayout";
import Table from "../../../../../Core/Table/Table";
import Tabs from "../../../../../Components/Tabs";
import ExportCSV from '../../../../../Core/Export/ExportCSV'
import ConfigureColumnsNew from "../../../../../Core/ConfigureColumnsNew/ConfigureColumnsNew";
import ListFilters from "../../../../../Core/ListFilters/ListFilters";
import { useDeleteDocMutation } from "../../../../../store/api/globalapi";
import DelConfirmPopup from "../../../../../Components/Popup/DelConfirmPopup ";
import useScreenHeight from "../../../../../utils/useScreenHeight";
import { useGetSelectedCompanyQuery } from "../../../../../store/api/companyapi";

const Lpntable = () => {
  const navigate = useNavigate();
	const { screenHeight, screenScaling , pageSize} = useScreenHeight();
  const [filters, setFilters] = useState({});
  const [currentPage, setCurrentPage] = useState(1);
  const [showColumnConfig, setShowColumnConfig] = useState(false);
  const [showExportPopup, setShowExportPopup] = useState(false);
  // States used for deleting the record
  const [deleteDoc] = useDeleteDocMutation();
	const [delPopupVisible, setDelPopupVisible] = useState(false);
	const [delSelectedId, setDelSelectedId] = useState(null);
	const [delmessage, setDelmessage] = useState();
	const [alreadySubmitData, setAlreadySubmitData] = useState(false);
	const [delDone, setDelDone] = useState(false);
  const { data } = useGetSelectedCompanyQuery();
  console.log("sleelcted data is here ",data);
  console.log("sleelcted data is here ",data?.message?.data?.company.split(" - ")[0]);
  const selectedComapny = data?.message?.data?.company.split(" - ")[0];

  // Build the frappe-style filter array (excluding Sl No.)


    const buildFilterArray = (filtersObj) => {
  const serverFilters = {};

  Object.entries(filtersObj).forEach(([key, value]) => {
    if (!value || value.trim() === "" || key === "SI No.") return;

    if (key === 'name') {
      serverFilters['name'] = value;
    } else if (key === 'warehouse_type') {
      serverFilters['warehouse_type'] = value;
    } else if (key === 'company') {
      serverFilters['company'] = value;
    } else if (key === 'disabled') {
      serverFilters['disabled'] = value;
    } else if (key === 'date') {
      serverFilters['creation'] = value;
    }
  });

  return serverFilters;
};


  const slNoInput = filters["S. No."]?.trim();

  const isSlNoActive = slNoInput && slNoInput !== "";
  const targetPage = isSlNoActive
    ? Math.max(1, Math.ceil(parseInt(slNoInput, 10) / pageSize))
    : currentPage;

   const [getwarehosuelist] = useGetWarehouseOnlyParentDataMutation();

   useEffect(()=>{
    const getdata = async() =>{
       const response  = await getwarehosuelist({
        doctype: '/method/stackerbee_mobile_wms.wms.react_api.get_bin_warehouses_list',
        limit_start: pageSize * (targetPage - 1),
        limit_page_length: pageSize,
        company:selectedComapny,
        filters:buildFilterArray(filters)
       });
        setwarehouseData(response.data);
  console.log("/api/method/stackerbee_mobile_wms.wms.react_api.get_parent_warehouses_list fff",response);

    }
     if(selectedComapny){
       getdata();
     }
   },[selectedComapny, pageSize,currentPage,screenHeight, screenScaling])
 
  const [warehouseData, setwarehouseData] = useState({full_data: [], total_no_of_records: 0 })
  // const warehouseData = paginatedData || { full_data: [], total_no_of_records: 0 };
  console.log("warehouseDatawarehouseData",warehouseData);
  // Handle Filter Change
  const handleFilterChange = (newFilters) => {
    setFilters(newFilters);

    if (newFilters["S. No."]?.trim()) {
      const sl = parseInt(newFilters["SI No."], 10);
      if (!isNaN(sl) && sl > 0) {
        setCurrentPage(Math.ceil(sl / pageSize));
      } else {
        setCurrentPage(1);
      }
    } else {
      setCurrentPage(1);
    }
  };

  // Table columns
  const [columnsConfig, setColumnsConfig] = useState([]);
  useEffect(() => {
    setColumnsConfig([
      {
        header: "S. No.",
        name: "S. No.",
        accessor: "siNo",
        width: '7%',
        visible: true,
        sortable: false,
        cellRenderer: (row, rowIndex) =>
          rowIndex + 1 + (pageSize * (targetPage - 1)),
      },
      {
        header: "Bin Name",
        name: "Bin Name",
        accessor: "name",
        width: '20%',
        visible: true,
        sortable: true,
      },
      // {
      //   header: "Type",
      //   name: "Type",
      //   accessor: "warehouse_type",
      //   visible: true,
      //   width: '15%',
      //   sortable: true
      // },
      {
        header: "Company",
        name: "Company",
        accessor: "company",
        visible: true,
        width: '25%',
        sortable: true
      },
      {
        header: "Status",
        name: "Status",
        accessor: "disabled",
        visible: true,
        width: '10%',
        sortable: true,
        cellRenderer: (row) => (
          <span style={{ color: row.disabled ? '#EF4444' : '#16A34A' }}>
            {row.disabled ? 'Disabled' : 'Enabled'}
          </span>
        )
      },
      {
        header: "Created On",
        name: "Created On",
        accessor: "creation",
        width: '15%',
        visible: true,
        sortable: true,
        cellRenderer: (row) =>
          row.creation ? new Date(row.creation).toLocaleDateString() : ""
      },
      {
        header: "Action",
        name: "Action",
        accessor: "action",
        visible: true,
        width: '18%',
        sortable: false,
        cellRenderer: (row) => (
          <ActionButtonDropdown
            id={row.name}
            onView={() => handleView(row.name)}
            onEdit={() => handleEdit(row.name)}
            onDelete={() => handleDelete(row.name)}
          />
        )
      },
    ])
  },[currentPage])

  // Handle column configuration changes
  const handleSaveColumns = (selectedKeys, allFields) => {
    const updatedColumns = columnsConfig.map(column => {
      return {
        ...column,
        visible: selectedKeys.includes(column.accessor)
      };
    });
    setColumnsConfig(updatedColumns);
  };

  const visibleColumns = useMemo(() =>
    columnsConfig.filter(col => col.visible === true),
    [columnsConfig]
  );

  const defaultSelectedColumns = useMemo(() =>
    columnsConfig
      .filter(col => col.visible === true)
      .map(col => ({
        fieldname: col.accessor,
        label: col.name
      }))
      .filter(col => col.fieldname),
    [columnsConfig]
  );
  const activeFilterCount = useMemo(() => {
    return Object.values(filters).filter(val => val !== null && val !== undefined && val !== '').length;
  }, [filters]);

  // SearchFilters config
  const filtersConfig = [
    { name: 'S. No.', label: 'S. No.', width: '5%', type: 'text' },
    { name: 'name', label: 'Bin Name', width: '20%', type: 'text' },
    // { name: 'warehouse_type', label: 'Type', width: '15%', type: 'text' },
    { name: 'company', label: 'Company', width: '17%', type: 'text' },
    { name: 'disabled', label: 'Status', width: '15%', type: 'select',  options: [
        { value: '0', label: 'Active' },
        { value: '1', label: 'Disabled' }
      ]
    },
    { name: 'date', label: 'Date', type: 'date', width: '15%' },
  ];

  // Action Handlers
  const handleView = (id) => {
    navigate('/master/bin-view', { state: { name: id } });
  };
  const handleEdit = (id) => {
    navigate('/master/bin-edit', { state: { name: id } });
  };
  const handleDelete = (id) => {
      setDelSelectedId(id);
      setDelPopupVisible(true)
      setAlreadySubmitData(false)
      setDelmessage("Are you sure you want to Delete this Warehouse?");
  };

  const delHandleCancel = () => {
      setDelPopupVisible(false);
      setDelSelectedId(null);
    }

  const delHandleConfirm = async () => {
        
      try {
          await deleteDoc({ doctype: "Warehouse", name: delSelectedId }).unwrap()
          setDelmessage(`Warehouse ${delSelectedId} deleted successfully!`)
          setDelDone(true)
          setTimeout(() => {
              setDelPopupVisible(false);
              setDelSelectedId(null);
              setDelDone(false);
            }, 1000);
        } catch (err) {
            console.error("Deletion Failed:", err)

            let errorMessage = "Failed to delete the Warehouse!";

            //If the server is sending the error message , we will extract it.
            if (err?.data?._server_messages) {
                try {
                    const messageArr = JSON.parse(err.data._server_messages)
                    if (messageArr && messageArr.length > 0) {
                        //parse inner json object
                        const messageObj = JSON.parse(messageArr[0])
                        if (messageObj?.message) {
                            //extract the exact message we want
                            const fullMessage = messageObj.message
                            errorMessage = fullMessage.split('You must')[0].trim();
                            //remove html in the message
                            errorMessage = errorMessage.replace(/<[^>]+>/g, '');

                        }
                    }
                } catch (parseError) {
                    console.error("Error parsing server messages:", parseError);
                }
            }
            setDelPopupVisible(true)
            setDelmessage(errorMessage)
            setAlreadySubmitData(true);
        } finally {
            // setTimeout(() => {
            //     setDelPopupVisible(false);
            //     setDelSelectedId(null);
            // }, 2000);
        }
    };

  const actionButtons = [
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "IoFilterSharp",
      iconSize: 12,
      children: activeFilterCount > 0 ? `Filter (${activeFilterCount})` : "Filter",
      onClick: () => {
        setShowFilters(prev => !prev);
        setShowColumnConfig(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "MdOutlineRemoveRedEye",
      iconSize: 12,
      children: "Show more",
      onClick: () => {
        setShowColumnConfig(prev => !prev);
        setShowFilters(false);
      }
    },
    {
      className: "createbtn border-0 d-flex",
      style: { gap: '2px', height: '28px' },
      iconName: "RiFileExcel2Fill",
      iconSize: 12,
      children: "Export Excel",
      onClick: () => setShowExportPopup(true),
    },
   {
      className: "custom-btn-00989 d-flex",
      to: "/master/create-bin",
      iconName: "FiPlus",
      style: { gap: "2px", height: "28px" },
      children: "Add New Bin"
    }
  ];

  const [showFilters, setShowFilters] = useState(false)
  const accessors = columnsConfig
		.filter(
			(column) => column.accessor !== "siNo" && column.accessor !== "action"
		)
		.map((column) => column.accessor);

  return (
		<div
			className="container-fluid d-flex flex-column"
			style={{ flexGrow: "1" }}
		>
			<Tabs />
			<ListLayout
				breadcrumbItems={[
					{ label: "Bin" },
					{ label: "Bin List", style: { color: "#270B79" } },
				]}
				actionButtons={actionButtons}
			>
				{showFilters && (
					<ListFilters
						filtersConfig={filtersConfig}
						onFilterChange={handleFilterChange}
						currentFilters={filters}
						setShowFilters={setShowFilters}
					/>
				)}
				{showColumnConfig && (
					<ConfigureColumnsNew
						show={showColumnConfig}
						onClose={() => setShowColumnConfig(false)}
						onSave={handleSaveColumns}
						docType="Warehouse"
						defaultSelected={defaultSelectedColumns}
						fieldsData={columnsConfig.map((col) => ({
							fieldname: col.accessor,
							label: col.name,
						}))}
						disabledFields={["siNo", "disabled", "action", "creation", "name"]}
					/>
				)}

				<Table
					columns={visibleColumns}
					data={warehouseData.full_data ? warehouseData.full_data : []}
					loading={false}
				/>
				<Pagination
					setCurrentPage={setCurrentPage}
					pageSize={pageSize}
					totalRecords={warehouseData.total_no_of_records ? warehouseData.total_no_of_records : [] || 0}
					currentPage={currentPage}
					className="mt-2 pb-3"
				/>

				{delPopupVisible && (
					<DelConfirmPopup
						alredysubmitdata={alreadySubmitData}
						delSelectedId={delSelectedId}
						visible={delPopupVisible}
						message={delmessage}
						onConfirm={delHandleConfirm}
						onCancel={delHandleCancel}
						delDone={delDone}
					/>
				)}
				{showExportPopup && (
					<ExportCSV
            doctype="Warehouse"
            fieldsData={accessors}
						onClose={() => setShowExportPopup(false)}
					/>
				)}
			</ListLayout>
		</div>
	);
};

export default Lpntable;
